import { GENERIC_REQUIRED_MESSAGE } from '@/utils';
import { object, string, ref } from 'yup';
import { ResetPasswordFormValues } from './types';

export default object<ResetPasswordFormValues>().shape({
  password: string().required(GENERIC_REQUIRED_MESSAGE),
  confirmPassword: string().oneOf([ref('password'), null], 'Passwords must match'),
});
